import React, {
  ComponentType
} from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { ENCOUNTER } from '../../../constant'
import { Encounter } from '../../authenticated/types'
import { ObjectValues } from '../../../types/types'

const SafeSegment = Segment as unknown as ComponentType<any>

type EncounterStatusProps = {
  encounter: Encounter
  mode?: string
}

type EncounterStatusValue = ObjectValues<typeof ENCOUNTER.STATUS>

/**
 * Provides a component that renders the encounter status
 * @param encounter Encounter entity
 * @param mode Render mode. Default: left
 */
function EncounterStatus(props: EncounterStatusProps): JSX.Element | null {
  const {
    encounter,
    mode: modeProp
  } = props

  const mode = modeProp || 'left'

  const getStatusText = (status: EncounterStatusValue | null | undefined): JSX.Element => {
    if (!status) {
      return <div className="left-content" />
    }
    if (status === ENCOUNTER.STATUS.CANCELLED) {
      return (
        <div className="left-content-red">{ status }</div>
      )
    }
    if (status === ENCOUNTER.STATUS.IGNORED) {
      return (
        <div className="left-content-red">{ status }</div>
      )
    }
    return (
      <div className="left-content">{ status }</div>
    )
  }

  const renderLeft = (encounterData: Encounter): JSX.Element => (
    <SafeSegment
      attached
      compact
      className="left-segment"
    >
      <div className="left-title">Encounter Status:</div>
      { getStatusText(encounterData.status) }
    </SafeSegment>
  )

  if (mode === 'left') {
    return renderLeft(encounter)
  }
  return null
}

export default EncounterStatus
